// extracted by mini-css-extract-plugin
export var compare = "style-module--compare--f0694";
export var footerBanner = "style-module--footerBanner--71b51";
export var helpBlock = "style-module--helpBlock--47b13";
export var interest = "style-module--interest--7e1b7";